import * as tslib_1 from "tslib";
import { BaseComponent } from "@impacgroup/angular-baselib";
var PointsOfInterestMainComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PointsOfInterestMainComponent, _super);
    function PointsOfInterestMainComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PointsOfInterestMainComponent;
}(BaseComponent));
export { PointsOfInterestMainComponent };
